import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

const CreationCard = () => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const [imgSource, setImgSource] = useState("mobile");

  useEffect(() => {
    isDesktop ? setImgSource("desktop") : setImgSource("mobile");
  }, [isDesktop]);

  return (
    <section className="section-creation wrapper">
      <div className="header-creation">
        <h2> Our creations</h2>
        {isDesktop && (
          <button>
            <a href="#">See all</a>
          </button>
        )}
      </div>

      <ul className="card-container">
        <li>
          <img
            src={`./assets/${imgSource}/image-deep-earth.jpg`}
            alt="image-deep-earth"
          />

          <h4>
            DEEP <br /> EARTH
          </h4>
        </li>
        <li>
          <img
            src={`./assets/${imgSource}/image-night-arcade.jpg`}
            alt="image-night-arcade"
          />
          <h4>
            Night <br /> Arcade
          </h4>
        </li>
        <li>
          <img
            src={`./assets/${imgSource}/image-soccer-team.jpg`}
            alt="image-soccer-team"
          />
          <h4>
            Soccer <br /> team vr
          </h4>
        </li>
        <li>
          <img src={`./assets/${imgSource}/image-grid.jpg`} alt="image-grid" />
          <h4>
            The <br /> grid
          </h4>
        </li>
        <li>
          <img
            src={`./assets/${imgSource}/image-from-above.jpg`}
            alt="image-from-above"
          />
          <h4>
            From up <br /> above vr
          </h4>
        </li>
        <li>
          <img
            src={`./assets/${imgSource}/image-pocket-borealis.jpg`}
            alt="image-pocket-borealis"
          />
          <h4>
            Pocket <br /> borealis
          </h4>
        </li>
        <li>
          <img
            src={`./assets/${imgSource}/image-curiosity.jpg`}
            alt="image-curiosity"
          />
          <h4>
            The <br /> curiosity
          </h4>
        </li>
        <li>
          <img
            src={`./assets/${imgSource}/image-fisheye.jpg`}
            alt="image-fisheye"
          />
          <h4>
            Make it <br /> fisheye
          </h4>
        </li>
      </ul>

      {!isDesktop && (
        <button>
          <a href="#">See all</a>
        </button>
      )}
    </section>
  );
};

export default CreationCard;
